module.exports = "/images/error-icon.svg?b85936974015c7af3cd3bd4df1179222";